const getFirstLetter = (arg) => (arg ? arg.split('')[0].toUpperCase() : '');

const getInitials = (firstName, lastName) =>
  `${getFirstLetter(firstName)}${getFirstLetter(lastName)}`;

export default getInitials;
